<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__info">
      <div class="info-row">
        <span class="label">Тип проекта:</span>
        <span class="value">{{ this.data?.body?.project_type_name }}</span>
      </div>
    </div>

    <div class="form__item">
      <CustomInput
        label="Гарантия если материалы от подрядчика (%)"
        :value="this.formData.warranty_contractor"
        @change_input="(value) => onChange('warranty_contractor', value)"
        type="number"
        required
        :min="0"
        step="0.1"
      />
    </div>

    <div class="form__item">
      <CustomInput
        label="Гарантия если материалы от команды проекта (%)"
        :value="this.formData.warranty_team_project"
        @change_input="(value) => onChange('warranty_team_project', value)"
        type="number"
        required
        :min="0"
        step="0.1"
      />
    </div>

    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "EditProjectTypeWarranty",
  components: { CustomInput, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      formData: {
        warranty_contractor:
          this.data?.body?.warranty_contractor ?? null,
        warranty_team_project:
          this.data?.body?.warranty_team_project ?? null,
      },
    };
  },
  methods: {
    onChange(key, value) {
      if (value === "" || value === null || value === undefined) {
        this.formData[key] = null;
      } else {
        const numValue = parseFloat(value);
        this.formData[key] = isNaN(numValue) ? null : numValue;
      }
    },
    async onSubmit() {
      if (
        this.formData.warranty_contractor === null ||
        this.formData.warranty_contractor === undefined ||
        this.formData.warranty_team_project === null ||
        this.formData.warranty_team_project === undefined
      ) {
        return;
      }
      this.loading = true;
      await this.data?.onSubmit(this.formData);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 400px;
  gap: 15px;

  &__info {
    background: #f5f5f5;
    padding: 12px;
    border-radius: 4px;

    .info-row {
      display: flex;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        font-weight: 600;
        margin-right: 8px;
      }

      .value {
        color: #555;
      }
    }
  }

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;
  }

  @media (max-width: 460px) {
    width: 100%;
  }
}
</style>
